import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoginServico } from '../servicos/login.servico';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilServico } from '../servicos/util.servico';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { map } from 'rxjs/operators';
import { GovBrServico } from '../servicos/govbr.servico';
import { AcessoCidadaoServico } from '../servicos/acessoCidadao.servico';

declare var jquery: any;
declare var $: any;
declare var swal: any;
export class TermoLGPD {
  PORTAL_LGP_URL: string;
  PORTAL_LGPD_TEXTO_URL: string;
  PORTAL_LGPD_TEXTO: string;
  PORTAL_LGP_HABILITAR_PORTAL:boolean;
}
@Component({
  selector: 'app-login',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  LOGIN: any;
  Mostrar: any;
  RECUPERAR_SENHA: any;
  RECUPERAR_SENHA_RESPOSTAS_USUARIO: any;
  MENSAGEM_USUARIO: any;
  RECUPERAR_SENHA_PERGUNTAS: any;
  RECUPERAR_SENHA_PERG_01: any;
  RECUPERAR_SENHA_PERG_02: any;
  RECUPERAR_SENHA_PERG_03: any;
  RECUPERAR_SENHA_SENHA_TEMPORARIA: any;
  Url: string;
  RECADASTRAMENTO: "N";
  RECADASTRAMENTO_LINK: "";
  LembrarAcessoValue: boolean;
  TermoLGPD: TermoLGPD = new TermoLGPD();
  textoTermoPolitica: string = '';
  isTermoAceito: boolean = false;
  parametros: any;
  DECLARACAO_EXISTENCIA_INEXISTENCIA_BENEFICIO_RPPS: any;
  PORTAL_LGP_HABILITAR_PORTAL: boolean = false;
  tipoVerificacaoUsuario: string = "S";
  DadosNovoCadastro: any;

  constructor(
    private http: Http,
    private loginServico: LoginServico,
    private router: Router,
    private UtilServico: UtilServico,
    private govBrServico: GovBrServico,
    private acessoCidadaoServico: AcessoCidadaoServico,
    private route: ActivatedRoute
  ) {
    this.http.get("assets/config.json").subscribe(data => {
      this.Url = data.json().BASE_WEB_API;
      this.RECADASTRAMENTO = data.json().RECADASTRAMENTO;
      this.RECADASTRAMENTO_LINK = data.json().RECADASTRAMENTO_LINK;
      this.getTermoLGPD();
      this.GetParametros();
      this.govBrServico.inicializarConfiguracoes();
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const state = params['state'];
      const isAcessoCidadao = state && state.startsWith('acesso_');
      this.DadosNovoCadastro = {};

      if (code && state) {
        this.Mostrar = true;
        
        this.http.get("assets/config.json").subscribe(data => {
          this.Url = data.json().BASE_WEB_API;

          let codeVerifier = localStorage.getItem("code_verifier");

          let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
          let options = new RequestOptions({ headers: headers });
           const urlLogin = isAcessoCidadao
          ? this.Url + "api/Login/AutenticarAcessoCidadao"
          : this.Url + "api/Login/AutenticarGovBr";
          this.http.post(
            urlLogin,
            JSON.stringify({ code: code, codeVerifier: codeVerifier }),
            options
            )
            .pipe(map((response: Response) => response.json()))
            .subscribe(
              data => {
                localStorage.setItem('DadosConfiguracoes', JSON.stringify(data));
                localStorage.removeItem('notificacaoVisualizada');

                const dadosAcesso = Object.assign(data, {
                  URL: this.Url,
                  RECADASTRAMENTO: this.RECADASTRAMENTO,
                  RECADASTRAMENTO_LINK: this.RECADASTRAMENTO_LINK
                });

                localStorage.setItem('AcessoAdm', JSON.stringify(dadosAcesso));

                this.router.navigate(['/inicial']);

                this.Mostrar = false;
              },
              error => {
                this.Mostrar = false;

                if (error.status == 0) {
                  swal({
                    title: "Atenção!",
                    type: "warning",
                    text: "Não foi possível conectar no servidor banco de dados!"
                  });
                }
                else {
                  swal({
                    title: "Atenção!",
                    type: "warning",
                    text: "Usuário não encontrado ou senha inválida!"
                  });
                }
              }
            );
        });
      }
    });
   
    this.loginServico.logout();
    this.LOGIN = {};
    if (localStorage.getItem('UsuarioPortalSegurado')) {
      // console.log('if');
      this.LembrarAcessoValue = true;
      this.LOGIN.USUARIO = localStorage.getItem('UsuarioPortalSegurado');
    }
    else {
      // console.log('else');
      this.LembrarAcessoValue = false;
    }
    this.RECUPERAR_SENHA = {};
    this.RECUPERAR_SENHA_PERG_01 = {};
    this.RECUPERAR_SENHA_PERG_02 = {};
    this.RECUPERAR_SENHA_PERG_03 = {};
    this.RECUPERAR_SENHA_RESPOSTAS_USUARIO = {};
    this.RECUPERAR_SENHA_SENHA_TEMPORARIA = {};
    localStorage.removeItem('exibirAlteracaoSenha');
    this.AdicionarEventosNavegacaoStep();
    this.RemoverItemLocalStorage();
  }

  GetParametros() {
    this.Mostrar = true;

    this.http.get(this.Url + "/api/Inicial/GetParametros")
      .pipe(map((response: Response) => response.json()))
      .subscribe(
        data => {
          this.Mostrar = false;
          
          this.parametros = data[0];

          this.DECLARACAO_EXISTENCIA_INEXISTENCIA_BENEFICIO_RPPS = this.parametros.DECLARACAO_EXISTENCIA_INEXISTENCIA_BENEFICIO_RPPS; 

          this.parametros.RECADASTRAMENTO_LINK = "";
        },
        error => {
          this.Mostrar = false;
        }
      );
  }

  
  getDynamicUrl(): string {
    const hostName = window.location.href;
    const validParts = hostName.split('/');
  
    if (validParts[2].includes("proxima") || validParts[2].includes("atual")) {
      return `${window.location.origin}/${validParts[3]}/sisprevweb/ProcessoBeneficio/DeclaracaoExistenciaInexistencia.aspx`;
    }
    return `${window.location.origin}/sisprevweb/ProcessoBeneficio/DeclaracaoExistenciaInexistencia.aspx`;
  }

  

  AcessarSistema() {
    if (this.isTermoAceito == false && this.PORTAL_LGP_HABILITAR_PORTAL == true) {

      swal({
        title: "Atenção!",
        type: "warning",
        text: "Para realizar o login é necessário aceitar o Termo de uso e Política de Privacidade."
      });

    } else {
      this.LembrarAcesso();
      this.Mostrar = true;
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
      let options = new RequestOptions({ headers: headers });
      this.http.post(this.Url + "/api/Login/Autenticar", JSON.stringify({ usuario: this.LOGIN.USUARIO, senha: this.LOGIN.SENHA }), options)
        .pipe(map((response: Response) => response.json()))
        .subscribe(
          data => {
            if(data == "N"){
              swal({
                title: "Atenção!",
                type: "warning",
                text: "Portal do segurado não disponível para essa categoria!"
              });
              this.Mostrar = false;
              return;
            }
            console.log(data);
            localStorage.setItem('DadosConfiguracoes', JSON.stringify(data));
            localStorage.removeItem('notificacaoVisualizada');
            const dadosAcesso = Object.assign(data, {
              URL: this.Url,
              RECADASTRAMENTO: this.RECADASTRAMENTO,
              RECADASTRAMENTO_LINK: this.RECADASTRAMENTO_LINK
            });
            localStorage.setItem('AcessoAdm', JSON.stringify(dadosAcesso));
            // localStorage.setItem('AcessoAdm', JSON.stringify(data));
            this.router.navigate(['/inicial']);
            this.Mostrar = false;
          },
          error => {
            this.Mostrar = false;
            if (error.status == 0) {
              swal({
                title: "Atenção!",
                type: "warning",
                text: "Não foi possível conectar no servidor banco de dados!"
              });
            }
            else {
              swal({
                title: "Atenção!",
                type: "warning",
                text: "Usuário não encontrado ou senha inválida!"
              });
            }
          }
        );
    }
  }
  getTermoLGPD() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });

    this.http.get(this.Url + "/api/Login/GetTermoLGPD/", options).subscribe(data => {
      this.TermoLGPD = Object.assign(this.TermoLGPD, data.json()[0])
      this.PORTAL_LGP_HABILITAR_PORTAL = this.TermoLGPD.PORTAL_LGP_HABILITAR_PORTAL;
      this.textoTermoPolitica = "<div class='quebrarLinha'>" + this.TermoLGPD.PORTAL_LGPD_TEXTO.replace("@url", `<a class='underline-text'  href='${this.TermoLGPD.PORTAL_LGP_URL}'>${this.TermoLGPD.PORTAL_LGPD_TEXTO_URL}</a>` + "</div>");
    }, error => {
      console.log(error);
      console.log(this.Url)
    })



  }

  inicializarEsqueceuSenha() {
    this.RECUPERAR_SENHA.USUARIO = "";
  
    this.tipoVerificacaoUsuario = "S";
  }
  
  inicializarNovoCadastro() {
    this.RECUPERAR_SENHA.USUARIO = "";
  
    this.tipoVerificacaoUsuario = "C";
  }
  
  EnviarSolicitacaoNovoCadastro() {
    let mensagemValidadao = this.ValidarNovoCadastro();
  
    if (mensagemValidadao){
      swal({
        title: "Atenção!",
        type: "warning",
        text: "Atenção! Para prosseguir com a operação, preencha os seguintes campos obrigatórios:\n" + mensagemValidadao
      });
  
      return;
    }
  
    this.Mostrar = true;
  
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });
  
    this.http.post(this.Url + "/api/Login/EnviarSolicitacaoCadastro", JSON.stringify(
      {
        nome: this.DadosNovoCadastro.NOME,
        cpf: this. DadosNovoCadastro.CPF,
        dataNasc: this.DadosNovoCadastro.DATA_NASC,
        sexo: this.DadosNovoCadastro.SEXO,
        nomeMae: this.DadosNovoCadastro.NOME_MAE,
        email: this.DadosNovoCadastro.EMAIL
      }
    ), options)
    .pipe(map((response: Response) => response.json()))
    .subscribe(
      data => {
        this.Mostrar = false;
        swal({
          title: "Atenção!",
          type: "success",
          text: data.mensagem,
        },
        function () {
          $("div[id^=ModalNovoCadastro]").modal('hide');
          });

        this.http.post(this.Url + "/api/Login/EnviaCorreioSolicitacaoCadastro",
          JSON.stringify({
            assunto: "SOLICITAÇÃO DE CADASTRO NO PORTAL - " + this.DadosNovoCadastro.NOME,
            nomeSolicitante : this.DadosNovoCadastro.NOME
          })
        , options)
          .pipe(map((response: Response) => response.json()))
          .subscribe(
            data => {
              
            }, error => {

          })  
      },
      error => {
        this.Mostrar = false;
        
        swal({
          title: "Atenção!",
          type: "success",
          text: "Atenção: erro inesperado durante o envio da solicitação!",
        }, function () {
          $("div[id^=ModalNovoCadastro]").modal('hide');
        });
      }
    );

  }
  
  ValidarNovoCadastro(): string {
    let errorMessage = "";
  
    if (!this.DadosNovoCadastro.NOME || this.DadosNovoCadastro.NOME.trim() == "")
      errorMessage += "- Nome\n";
  
    if (!this.DadosNovoCadastro.CPF || this.DadosNovoCadastro.CPF.trim() == "")
      errorMessage += "- CPF\n";
  
    if (!this.DadosNovoCadastro.DATA_NASC)
      errorMessage += "- Data de Nascimento\n";
  
    if (!this.DadosNovoCadastro.SEXO || this.DadosNovoCadastro.SEXO == "0")
      errorMessage += "- Sexo\n";
  
    if (!this.DadosNovoCadastro.NOME_MAE  || this.DadosNovoCadastro.NOME_MAE.trim() == "")
      errorMessage += "- Nome da Mãe\n";
  
    if (!this.DadosNovoCadastro.EMAIL || this.DadosNovoCadastro.EMAIL.trim() == "")
      errorMessage += "- E-mail\n";
  
    return errorMessage;
  }
  
  LimparNovoCadastro() {
    this.DadosNovoCadastro.NOME = "";
    this.DadosNovoCadastro.NOME_MAE = "";
    this.DadosNovoCadastro.EMAIL = "";
    this.DadosNovoCadastro.CPF = this.RECUPERAR_SENHA.USUARIO;
    this.DadosNovoCadastro.SEXO = "0";
    this.DadosNovoCadastro.DATA_NASC = "";
  }

  RecuperarSenhaPerguntas() {
    this.Mostrar = true;
    
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });
  
    if (this.tipoVerificacaoUsuario == "S") {
      this.http.post(this.Url + "/api/Login/RecuperarSenhaPerguntas", JSON.stringify({ usuario: this.RECUPERAR_SENHA.USUARIO }), options)
        .pipe(map((response: Response) => response.json()))
        .subscribe(
          data => {
            this.RECUPERAR_SENHA_PERGUNTAS = data;
            this.Mostrar = false;
  
            if (this.RECUPERAR_SENHA_PERGUNTAS.CATEGORIA == "Segurado")
            {
              this.AdicionarEventosNavegacaoStep();
              this.AjustarMensagemUsuario();
              this.AvancarPerguntasNevegacao();
              this.AjustarPerguntasUsuario();
            }
            else
            {
              if (this.RECUPERAR_SENHA_PERGUNTAS.SUCESSO)
                swal({
                  title: "Sucesso!",
                  type: "success",
                  text: "E-mail de alteração de senha foi enviado com sucesso!",
                }, function () {
                  $("div[id^=stepModal]").modal('hide');
                });
              else
                swal({
                  title: "Atenção!",
                  type: "warning",
                  text: this.RECUPERAR_SENHA_PERGUNTAS.MENSAGEM
                }, function () {
                  $("div[id^=stepModal]").modal('hide');
                });
            }
          },
          error => {
            this.Mostrar = false;
            if (error.status == 0) {
              swal({
                title: "Atenção!",
                type: "warning",
                text: "Não foi possível conectar no servidor banco de dados!"
              });
            }
            else if (error.status == 404) {
              swal({
                title: "Atenção!",
                type: "warning",
                text: "Informação inválida! O CPF não possui vínculo com Cadastro de Usuário no Portal ativo!"
              });
            }
            else {
              swal({
                title: "Atenção!",
                type: "warning",
                text: "Informação inválida!"
              });
            }
          }
        );
    }
    else
    {
      this.http.post(this.Url + "/api/Login/VerificarNovoRegistro", JSON.stringify({ usuario: this.RECUPERAR_SENHA.USUARIO }), options)
      .pipe(map((response: Response) => response.json()))
      .subscribe(
        data => {
          this.Mostrar = false;
  
          if (data.CATEGORIA == "S") {
            swal({
              title: data.SUCESSO ? "Sucesso!" : "Atenção!",
              type: data.SUCESSO ? "success" : "warning",
              text: data.MENSAGEM
            }, function () {
              $("div[id^=stepModal]").modal('hide');
            });
          }
          else {
            this.LimparNovoCadastro();
  
            $("div[id^=stepModal]").modal('hide');
            $("div[id^=ModalNovoCadastro]").modal('show');
          }
        },
        error => {
          this.Mostrar = false;
          
          swal({
            title: "Atenção!",
            type: "warning",
            text: "Atenção: Erro inesperado durante o processamento!"
          }, function () {
            $("div[id^=stepModal]").modal('hide');
          });
        }
      );
    }
  }

  RecuperarSenhaEnviarRespostas() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });
    this.http.post(this.Url + "/api/Login/RecuperarSenhaVerificarRespostas",
      JSON.stringify({
        usuario: this.RECUPERAR_SENHA.USUARIO,
        perguntaid_01: this.RECUPERAR_SENHA_PERGUNTAS.PERGUNTAS_RESPOSTAS[0].PERGUNTA_ID,
        resposta01: this.RECUPERAR_SENHA_RESPOSTAS_USUARIO.RESPOSTA01,
        perguntaid_02: this.RECUPERAR_SENHA_PERGUNTAS.PERGUNTAS_RESPOSTAS[1].PERGUNTA_ID,
        resposta02: this.RECUPERAR_SENHA_RESPOSTAS_USUARIO.RESPOSTA02,
        perguntaid_03: this.RECUPERAR_SENHA_PERGUNTAS.PERGUNTAS_RESPOSTAS[2].PERGUNTA_ID,
        resposta03: this.RECUPERAR_SENHA_RESPOSTAS_USUARIO.RESPOSTA03
      }), options)
      .pipe(map((response: Response) => response.json()))
      .subscribe(
        data => {
          this.RECUPERAR_SENHA_SENHA_TEMPORARIA = data;
          this.LimparCamposRepostas();
          this.Mostrar = false;
          swal({
            title: "Seus dados foram validados com sucesso!",
            type: "success",
            text: `Senha provisória: ${this.RECUPERAR_SENHA_SENHA_TEMPORARIA}`
          }, function () {
            localStorage.setItem('exibirAlteracaoSenha', 'true');
            $("div[id^=stepModal]").modal('hide');
          })
        },
        error => {
          this.Mostrar = false;
          if (error.status == 0) {
            swal({
              title: "Atenção!",
              type: "warning",
              text: "Não foi possível conectar no servidor banco de dados!"
            });
          }
          else {
            swal({
              title: "",
              type: "warning",
              text: "Houve um erro em alguma(s) da(s) resposta(s), favor procurar uma unidade do Instituto de Previdência do Estado de Santa Catarina!!"
            });
          }
        }
      );
  }

  AjustarMensagemUsuario() {
    this.MENSAGEM_USUARIO = `Sr(a) ${this.RECUPERAR_SENHA_PERGUNTAS.NOME_USUARIO}, responda as perguntas corretamente para acessar através de uma senha temporária.`;
  }

  AjustarPerguntasUsuario() {
    this.RECUPERAR_SENHA_PERG_01 = this.RECUPERAR_SENHA_PERGUNTAS.PERGUNTAS_RESPOSTAS[0];
    this.RECUPERAR_SENHA_PERG_02 = this.RECUPERAR_SENHA_PERGUNTAS.PERGUNTAS_RESPOSTAS[1];
    this.RECUPERAR_SENHA_PERG_03 = this.RECUPERAR_SENHA_PERGUNTAS.PERGUNTAS_RESPOSTAS[2];
  }

  AvancarPerguntasNevegacao() {
    $("div[id^=stepModal01]").modal('hide');
    $("div[id^=stepModal01]").closest("div[id^='stepModal01']").nextAll("div[id^='stepModal02']").first().modal('show');
  }

  AdicionarEventosNavegacaoStep() {
    $(document).ready(function () {
      $("div[id^=stepModal]").each(function () {

        var currentModal = $(this);

        //click next
        currentModal.find('.btn-next').click(function () {
          currentModal.modal('hide');
          currentModal.closest("div[id^='stepModal']").nextAll("div[id^='stepModal']").first().modal('show');
        });

        //click prev
        currentModal.find('.btn-prev').click(function () {
          currentModal.modal('hide');
          currentModal.closest("div[id^='stepModal']").prevAll("div[id^='stepModal']").first().modal('show');
        });
      });
    });
  }

  LimparCamposRepostas() {
    this.RECUPERAR_SENHA.USUARIO = {};
    this.RECUPERAR_SENHA_RESPOSTAS_USUARIO = {};
  }

  RemoverItemLocalStorage() {
    localStorage.removeItem('exibirAlteracaoSenha');
  }

  LembrarAcessoClick() {
    this.LembrarAcessoValue = !this.LembrarAcessoValue;
    this.LembrarAcesso();
  }

  aceitarTermoPoliticaPrivacidade() {
    this.getTermoLGPD();
    this.isTermoAceito = !this.isTermoAceito;

    console.log(this.isTermoAceito);
  }

  LembrarAcesso() {
    if (this.LembrarAcessoValue === true) {
      localStorage.setItem('UsuarioPortalSegurado', JSON.stringify(this.LOGIN.USUARIO));
    }
    else {
      localStorage.removeItem('UsuarioPortalSegurado');
    }
  };

  RedirecionarLoginAcessoCidadao() {
  if (this.isTermoAceito) {
    swal({
      title: 'Atenção!',
      type: 'warning',
      text: 'Para realizar o login é necessário aceitar o Termo de uso e Política de Privacidade.'
    });
    return;
  }

  this.Mostrar = true;

  this.acessoCidadaoServico.inicializarConfiguracoes()
    .then(() => this.acessoCidadaoServico.UrlDeAutorizacao())
    .then((redirectUri: string) => {
      this.Mostrar = false;
      window.location.href = redirectUri;
    })
    .catch((error) => {
      this.Mostrar = false;
      swal({
        title: 'Atenção!',
        type: 'warning',
        text: 'Erro ao redirecionar para o Acesso Cidadão.'
      });
    });
  }

  RedirecionarLoginGovBr() {
    if (!this.isTermoAceito) {
      swal({
        title: "Atenção!",
        type: "warning",
        text: "Para realizar o login é necessário aceitar o Termo de uso e Política de Privacidade."
      });

      return;
    }

    this.Mostrar = true;

    this.govBrServico.UrlDeAutorizacao().then((redirectUri: string) => {
      this.Mostrar = false;

      window.location.href = redirectUri;
    }).catch((error) => {
      this.Mostrar = false;

      swal({
        title: "",
        type: "warning",
        text: "Houve um erro: " + error
      });
    });
  }
}
